(() => {
  'use strict';
  if (!customElements.get('tq-pivot')) customElements.define('tq-pivot', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const video = this.querySelector('video');
      const button = this.querySelector('[data-tq-play]');
      const seek = this.querySelector('[data-tq-seek]');
      if (!video || !button || !seek) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const label = button.querySelector('[data-tq-play-label]');
      video.id = button.getAttribute('aria-controls');
      const sync = () => {
        label.textContent = video.ended ? this.dataset.replay : video.paused ? this.dataset.play : this.dataset.pause;
        button.setAttribute('aria-label', label.textContent);
        if (Number.isFinite(video.duration) && video.duration > 0) seek.value = String(video.currentTime / video.duration * 100);
      };
      button.addEventListener('click', async () => {
        if (!video.paused) { video.pause(); return; }
        if (video.ended) video.currentTime = 0;
        try { await video.play(); } catch (_) { video.controls = true; this.querySelector('.tq-pivot__controls').hidden = true; }
      }, options);
      seek.addEventListener('input', () => { if (Number.isFinite(video.duration)) video.currentTime = Number(seek.value) / 100 * video.duration; }, options);
      ['play', 'pause', 'ended', 'timeupdate', 'loadedmetadata'].forEach(event => video.addEventListener(event, sync, options));
      this.observer = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) video.pause(); }, { threshold: 0.1 });
      this.observer.observe(video);
      video.controls = false;
      this.querySelector('.tq-pivot__controls').hidden = false;
      sync();
    }
    disconnectedCallback() { this.querySelector('video')?.pause(); this.controller?.abort(); this.controller = null; this.observer?.disconnect(); }
  });
  if (!customElements.get('tq-hotspots')) customElements.define('tq-hotspots', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const buttons = [...this.querySelectorAll('[data-tq-point]')];
      const show = key => {
        this.dataset.selected = key;
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.tqPoint === key)));
        this.querySelectorAll('[data-tq-panel]').forEach(panel => { panel.hidden = panel.dataset.tqPanel !== key; });
      };
      buttons.forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => show(button.dataset.tqPoint), options);
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const next = button.dataset.tqPoint === 'poles' ? 'pocket' : 'poles';
          show(next);
          const group = button.closest('.tq-explore__choices') || button.closest('.tq-explore__visual');
          group?.querySelector(`[data-tq-point="${next}"]`)?.focus();
        }, options);
      });
      const dialog = this.querySelector('[data-tq-detail-dialog]');
      const opener = this.querySelector('[data-tq-detail-open]');
      if (dialog && opener) {
        const close = () => dialog.close();
        opener.addEventListener('click', () => { if (!dialog.open) dialog.showModal(); }, options);
        dialog.querySelector('[data-tq-detail-close]').addEventListener('click', close, options);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
        }, options);
        dialog.addEventListener('close', () => opener.focus({ preventScroll: true }), options);
      }
      this.classList.add('is-enhanced');
      show('poles');
    }
    disconnectedCallback() { this.querySelector('dialog[open]')?.close(); this.controller?.abort(); this.controller = null; }
  });
  if (!customElements.get('tq-buy-bar')) customElements.define('tq-buy-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const root = this.closest('[data-tq-product]');
      const native = root?.querySelector('.product-form__submit');
      const button = this.querySelector('button');
      if (!native || !button) return;
      this.controller = new AbortController();
      const sync = () => {
        button.disabled = native.disabled || native.getAttribute('aria-disabled') === 'true';
        button.textContent = native.textContent.trim();
        this.querySelector('[data-tq-sticky-price]').textContent = (root.querySelector('.price-item--sale') || root.querySelector('.price-item--regular'))?.textContent.trim() || '';
      };
      const visibility = () => {
        const visible = native.getBoundingClientRect().bottom < 0;
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', String(!visible));
      };
      this.observer = new IntersectionObserver(visibility); this.observer.observe(native);
      this.mutation = new MutationObserver(sync); this.mutation.observe(native, {attributes:true,childList:true,subtree:true});
      window.addEventListener('scroll', visibility, {passive:true,signal:this.controller.signal});
      button.addEventListener('click', () => { if (!button.disabled) native.click(); }, {signal:this.controller.signal});
      sync();visibility();
    }
    disconnectedCallback() { this.controller?.abort();this.controller = null;this.observer?.disconnect();this.mutation?.disconnect(); }
  });
})();
